export default "__VITE_ASSET__d6f4844e__"